import { CommonModule } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { DocumentReference } from '@angular/fire/firestore';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { IInventoryLocationCreateForm } from '@inventory/models/inventory-forms';
import { InventoryLocationsService } from '@inventory/services/inventory-locations/inventory-locations.service';
import { StandardControlComponent } from '@shared/components/forms/standard-control/standard-control.component';
import { TextareaControlComponent } from '@shared/components/forms/textarea-control/textarea-control.component';
import { ToastTypes } from '@shared/models/toast';
import { OffcanvasService } from '@shared/services/offcanvas/offcanvas.service';
import { ToastService } from '@shared/services/toast/toast.service';

@Component({
	selector: 'app-inventory-location-create-offcanvas',
	imports: [CommonModule, StandardControlComponent, TextareaControlComponent],
	templateUrl: './inventory-location-create-offcanvas.component.html',
	styleUrl: './inventory-location-create-offcanvas.component.scss',
	host: {
		class: 'h-100',
		style: 'display: contents',
	},
})
export class InventoryLocationCreateOffcanvasComponent implements OnInit {
	@Input() organisationRef: DocumentReference;

	private inventoryLocationsService = inject(InventoryLocationsService);
	private offcanvasService = inject(OffcanvasService);
	private toastService = inject(ToastService);

	form: FormGroup<IInventoryLocationCreateForm>;

	isSubmitting: boolean = false;

	ngOnInit(): void {
		this.form = new FormGroup<IInventoryLocationCreateForm>({
			name: new FormControl<string | null>(null, [Validators.required, Validators.minLength(2), Validators.maxLength(100)]),
			description: new FormControl<string | null>(null, [Validators.maxLength(500)]),
		});
	}

	close(): void {
		this.offcanvasService.dismissLast();
	}

	submit(): void {
		if (this.form.invalid) {
			return;
		}

		this.isSubmitting = true;

		this.inventoryLocationsService
			.createInventoryLocation(this.organisationRef, this.form)
			.then(() => {
				this.isSubmitting = false;
				this.offcanvasService.dismissLast();
			})
			.catch((error) => {
				console.error('Error creating inventory location:', error);
				this.isSubmitting = false;
				this.toastService.showToast({
					title: 'Inventory Location',
					message: `Failed to create inventory location: ${error.message}`,
					type: ToastTypes.ERROR,
				});
			});
	}
}
